import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const arrayContainsByFieldValidationRuleResolver: BaseValidationRuleResolver<any[]> = (value, rule) => {
  if (!Array.isArray(value)) {
    throw new Error('Expected an array value.');
  }

  const fieldId = rule?.fieldId;
  const expectedValue = rule?.value;
  if (!fieldId || expectedValue === undefined || expectedValue === null) {
    throw new Error("Validation rule 'arrayContainsByField' requires 'fieldId' and 'value'.");
  }

  const hasMatch = value.some((item) => item && typeof item === 'object' && item[fieldId] === expectedValue);
  return hasMatch ? null : 'Required';
};
